import { render } from "./modalSalesOffer.vue?vue&type=template&id=5a964cf7"
import script from "./modalSalesOffer.vue?vue&type=script&lang=js"
export * from "./modalSalesOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__